import { apiSlice } from "./apiSlice";
import prepareQueryParams from './queryParams';
const endpoints_config = [
  {
    name: "stats",
    path: (params) => `/api/v3/crm/stats`,
    method: "GET",
    description: "dashboard stats"
  },
  {
    name: "chargingPartners",
    path: (params) => `/api/v3/crm/charging_partners?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing charging partners"
  },
  {
    name: "operators",
    path: (params) => `/api/v3/crm/operators?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing operators"
  },
  {
    name: "blockOperator",
    path: (params) => `/api/v3/crm/operators/${params.id}/block`,
    method: "PUT",
    description: "block operator",
  },
  {
    name: "unBlockOperator",
    path: (params) => `/api/v3/crm/operators/${params.id}/unblock`,
    method: "PUT",
    description: "unblock operator",
  },
  {
    name: "archiveOperator",
    path: (params) => `/api/v3/crm/operators/${params.id}/archive`,
    method: "PUT",
    description: "archive operator",
  },
  {
    name: "unArchiveOperator",
    path: (params) => `/api/v3/crm/operators/${params.id}/unarchive`,
    method: "PUT",
    description: "unarchive operator",
  },
  {
    name: "distributorDetails",
    path: (params) => `/api/v3/crm/charging_partners/${params.id}?fields=show&${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing charging partners"
  },
  {
    name: "fleetOwnerDetails",
    path: (params) => `/api/v3/crm/fleet_owners/${params.id}?fields=show&${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing fleet owners"
  },
  {
    name: "customers",
    path: (params) => `/api/v3/crm/customers?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing customers"
  },
  {
    name: "dsc_coordinators",
    path: (params) => `/api/v3/crm/dsc_coordinators?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing dsc coordinators"
  },
  {
    name: "technicians",
    path: (params) => `/api/v3/crm/technicians?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing technicians"
  },
  {
    name: "showCustomer",
    path: (params) => `/api/v3/crm/customers/${params.id}?fields=show`,
    method: "GET",
    description: "get customer details",
  },
  {
    name: "groups",
    path: (params) => `/api/v3/crm/groups?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing groups"
  },
  {
    name: "walletTransactions",
    path: (params) => `/api/v3/crm/wallet_transactions?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing wallet transactions"
  },
  {
    name: "challans",
    path: (params) => `/api/v3/crm/challans?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing customers challans History"
  },
  {
    name: "platfromPartners",
    path: (params) => `/api/v3/crm/platform_partners?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing platfrom partners"
  },
  {
    name: "fleetOwners",
    path: (params) => `/api/v3/crm/fleet_owners?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing fleet owners"
  },
  {
    name: "batteries",
    path: (params) => `/api/v3/crm/batteries?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all batteries"
  },
  {
    name: "batteryModels",
    path: (params) => `/api/v3/crm/battery_models?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all battery models"
  },
  {
    name: "createBatteryModel",
    path: (params) => `/api/v3/crm/battery_models`,
    method: "POST",
    description: "creating new battery model",
  },
  {
    name: "showBatteryModel",
    path: (params) => `/api/v3/crm/battery_models/${params.id}?fields=show`,
    method: "GET",
    description: "get battery model details",
  },
  {
    name: "updateBatteryModel",
    path: (params) => `/api/v3/crm/battery_models/${params.id}`,
    method: "PUT",
    description: "update battery model details"
  },
  {
    name: "batteryTransactions",
    path: (params) => `/api/v3/crm/battery_transactions?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get all battery transactions"
  },
  {
    name: "showbatteryTransactionDetails",
    path: (params) => `/api/v3/crm/battery_transactions/${params.id}/more_details`,
    method: "GET",
    description: "get battery transaction more details"
  },
  {
    name: "chargingStations",
    path: (params) => `/api/v3/crm/charging_stations?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all charging stations"
  },
  {
    name: "rfids",
    path: (params) => `/api/v3/crm/rfids?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all rfids"
  },
  {
    name: "blockRfid",
    path: (params) => `/api/v1/rfids/block_crm`,
    method: "POST",
    description: "block rfid card",
  },
  {
    name: "unBlockRfid",
    path: (params) => `/api/v1/rfids/unblock`,
    method: "POST",
    description: "unblock rfid card",
  },
  {
    name: "markDefectiveRfid",
    path: (params) => `/api/v1/rfids/${params.id}/mark_defective`,
    method: "PUT",
    description: "mark rfid card defective"
  },
  {
    name: "chargingVerifications",
    path: (params) => `/api/v3/crm/charging_verifications?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing charging verifications"
  },
  {
    name: "chargingZoneLocations",
    path: (params) => `/api/v3/crm/charging_zones/locations?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing charging zone locations"
  },
  {
    name: "offers",
    path: (params) => `/api/v3/crm/offers?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing offers"
  },
  {
    name: "showOffer",
    path: (params) => `/api/v3/crm/offers/${params.id}?fields=show&${prepareQueryParams(params)}`,
    method: "GET",
    description: "show offer"
  },
  {
    name: "updateOffer",
    path: (params) => `/api/v3/crm/offers/${params.id}`,
    method: "PUT",
    description: "update offer"
  },
  {
    name: "createOffer",
    path: (params) => `/api/v3/crm/offers`,
    method: "POST",
    description: "create offer",
  },
  {
    name: "leaseOffers",
    path: (params) => `/api/v3/crm/lease_offers?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing lease offer",
  },
  {
    name: "changePassword",
    path: (params) => "/api/v3/crm/passwords",
    method: "POST",
    description: "change password"
  },
  {
    name: "sendChangePasswordOtp",
    path: (params) => "/api/v3/crm/passwords/send_otp",
    method: "POST",
    description: "send otp to change password"
  },
  {
    name: "verifyChangePasswordOtp",
    path: (params) => "/api/v3/crm/passwords/verify_otp",
    method: "POST",
    description: "verify otp to change password"
  },
  {
    name: "crmUsers",
    path: (params) => `/api/v3/crm/crm_users?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing crm users",
  },
  {
    name: "createCrmUser",
    path: (params) => `/api/v3/crm/crm_users`,
    method: "POST",
    description: "create crm user details",
  },
  {
    name: "showCrmUser",
    path: (params) => `/api/v3/crm/crm_users/${params.id}?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get crm user details",
  },
  {
    name: "updateCrmUser",
    path: (params) => `/api/v3/crm/crm_users/${params.id}`,
    method: "PUT",
    description: "update crm user details",
  },
  {
    name: "usersTypes",
    path: (params) => `/api/v3/crm/users_types?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing user roles"
  },
  {
    name: "zones",
    path: (params) => `/api/v3/crm/zones?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing zones"
  },
  {
    name: "headUsers",
    path: (params) => `/api/v3/crm/users/head_users?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing head users"
  },
  {
    name: "showUser",
    path: (params) => `/api/v3/crm/users/${params.id}`,
    method: "GET",
    description: "get user details",
  },
  {
    name: "updateUser",
    path: (params) => `/api/v3/crm/users/${params.id}`,
    method: "PUT",
    description: "update user details",
  },
  {
    name: "createUser",
    path: (params) => `/api/v3/crm/users`,
    method: "POST",
    description: "create user details",
  },
  {
    name: "findUser",
    path: (params) => `/api/v3/crm/users/find?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get user details by parameters like mobile number, name, id,....",
  },
  {
    name: "clusters",
    path: (params) => `/api/v3/crm/clusters?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing clusters"
  },
  {
    name: "showCluster",
    path: (params) => `/api/v3/crm/clusters/${params.id}?fields=show`,
    method: "GET",
    description: "get cluster details",
  },
  {
    name: "createCluster",
    path: (params) => `/api/v3/crm/clusters`,
    method: "POST",
    description: "create cluster",
  },
  {
    name: "updateCluster",
    path: (params) => `/api/v3/crm/clusters/${params.id}`,
    method: "PUT",
    description: "update cluster details",
  },
  {
    name: "uiActions",
    path: (params) => `/api/v3/crm/ui_actions?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing and filtering ui actions, possible query params: user_id or users_type_id"
  },
  {
    name: "grantPermissions",
    path: (params) => "/api/v3/crm/ui_actions/grant_permissions",
    method: "POST",
    description: 'grant ui actions permissions to either user or users_type by respective ids' +
      'params to update permissions for users_type => { users_type_id: 20, permitted_actions: [] }' +
      'params to update permissions for user => { user_id: 123, permitted_actions: [] }'
  },
  {
    name: "electricityServiceProviders",
    path: (params) => `/api/v3/crm/electricity/service_providers?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing electricity service providers"
  },
  {
    name: "electricityClaims",
    path: (params) => `/api/v2/electricity/billings.json?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing electricity claims (billings)"
  },
  {
    name: "electricityConfigurations",
    path: (params) => `/api/v2/electricity/cz_load_configurations.json?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing electricity configurations"
  },
  {
    name: "workOrders",
    path: (params) => `/api/v3/crm/work_orders?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing work orders"
  },
  {
    name: "vehicleTypes",
    path: (params) => `/api/v3/crm/vehicle_types?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing vehicle types"
  },
  {
    name: "inspectionItems",
    path: (params) => `/api/v3/inspection_items?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing vehicle inspection items"
  },
  {
    name: "branches",
    path: (params) => `/api/v3/crm/branches?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing branches"
  },
  {
    name: "showBranch",
    path: (params) => `/api/v3/crm/branches/${params.id}?fields=show`,
    method: "GET",
    description: "get branch details",
  },
  {
    name: "createBranches",
    path: (params) => `/api/v3/crm/branches`,
    method: "POST",
    description: "create branch"
  },
  {
    name: "updateBranch",
    path: (params) => `/api/v3/crm/branches/${params.id}`,
    method: "PUT",
    description: "update branch details",
  },
  {
    name: "schemes",
    path: (params) => `/api/v3/crm/schemes?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing schemes"
  },
  {
    name: "showScheme",
    path: (params) => `/api/v3/crm/schemes/${params.id}`,
    method: "GET",
    description: "get scheme details",
  },
  {
    name: "updateScheme",
    path: (params) => `/api/v3/crm/schemes/${params.id}`,
    method: "PUT",
    description: "update scheme details",
  },
  {
    name: "createScheme",
    path: (params) => `/api/v3/crm/schemes`,
    method: "POST",
    description: "create scheme details",
  },
  {
    name: "addons",
    path: (params) => `/api/v3/crm/addons?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all add-ons",
  },
  {
    name: "createAddon",
    path: (params) => `/api/v3/crm/addons`,
    method: "POST",
    description: "creating new addon",
  },
  {
    name: "showAddon",
    path: (params) => `/api/v3/crm/addons/${params.id}`,
    method: "GET",
    description: "get addon details",
  },
  {
    name: "updateAddon",
    path: (params) => `/api/v3/crm/addons/${params.id}`,
    method: "PUT",
    description: "update addon details",
  },
  {
    name: "addonTypes",
    path: (params) => `/api/v3/crm/addons/addon_types?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get addon types",
  },
  {
    name: "offerAddons",
    path: (params) => `/api/v3/crm/offer_addons?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get offer addons",
  },
  {
    name: "createManyOfferAddons",
    path: (params) => `/api/v3/crm/offer_addons/create_many`,
    method: "POST",
    description: "creating new offer addon",
  },
  {
    name: "showOfferAddon",
    path: (params) => `/api/v3/crm/offer_addons/${params.id}`,
    method: "GET",
    description: "get offer addon details",
  },
  {
    name: "updateOfferAddon",
    path: (params) => `/api/v3/crm/offer_addons/${params.id}`,
    method: "PUT",
    description: "update offer addon details",
  },
  {
    name: "securityAmounts",
    path: (params) => `/api/v3/crm/security_amount_displays?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all security amounts",
  },
  {
    name: "createSecurityAmount",
    path: (params) => `/api/v3/crm/security_amount_displays`,
    method: "POST",
    description: "create security amount",
  },
  {
    name: "showSecurityAmountDisplay",
    path: (params) => `/api/v3/crm/security_amount_displays/${params.id}`,
    method: "GET",
    description: "get security amounts details",
  },
  {
    name: "updateSecurityAmountDisplay",
    path: (params) => `/api/v3/crm/security_amount_displays/${params.id}`,
    method: "PUT",
    description: "update security amounts",
  },
  {
    name: "pincodes",
    path: (params) => `/api/v3/crm/pincodes?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all pincodes",
  },
  {
    name: "showPincode",
    path: (params) => `/api/v3/crm/pincodes/${params.id}`,
    method: "GET",
    description: "get pincode details",
  },
  {
    name: "createPincode",
    path: (params) => `/api/v1/pincodes`,
    method: "POST",
    description: "create new pincode",
  },
  {
    name: "deletePincode",
    path: (params) => `/api/v1/pincodes/${params.id}`,
    method: "DELETE",
    description: "delete pincode",
  },
  {
    name: "dissociatePincode",
    path: (params) => `/api/v1/clusters/pincodes/${params.id}/remove`,
    method: "DELETE",
    description: "dissociate pincode from cluster",
  },
  {
    name: "warehouses",
    path: (params) => `/api/v3/crm/cs_ware_houses?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all warehouses",
  },
  {
    name: "showWarehouse",
    path: (params) => `/api/v3/crm/cs_ware_houses/${params.id}?fields=show`,
    method: "GET",
    description: "get warehouse details",
  },
  {
    name: "createWarehouse",
    path: (params) => `/api/v3/crm/cs_ware_houses`,
    method: "POST",
    description: "creating new warehouse",
  },
  {
    name: "updateWarehouse",
    path: (params) => `/api/v3/crm/cs_ware_houses/${params.id}`,
    method: "PUT",
    description: "update warehouse details",
  },
  {
    name: "categories",
    path: (params) => `/api/v3/crm/categories?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all categories",
  },
  {
    name: "showCategory",
    path: (params) => `/api/v3/crm/categories/${params.id}?fields=show`,
    method: "GET",
    description: "get complaint category details",
  },
  {
    name: "createCategory",
    path: (params) => `/api/v3/crm/categories`,
    method: "POST",
    description: "create new complaint category",
  },
  {
    name: "updateCategory",
    path: (params) => `/api/v3/crm/categories/${params.id}`,
    method: "PUT",
    description: "update complaint category details",
  },
  {
    name: "states",
    path: (params) => `/api/v3/crm/states?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all states",
  },
  {
    name: "districts",
    path: (params) => `/api/v3/crm/districts?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all districts",
  },
  {
    name: "serviceCenters",
    path: (params) => `/api/v3/crm/service_centers?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all service centers",
  },
  {
    name: "createServiceCenter",
    path: (params) => `/api/v3/crm/service_centers`,
    method: "POST",
    description: "creating new service center",
  },
  {
    name: "updateServiceCenter",
    path: (params) => `/api/v3/crm/service_centers/${params.id}`,
    method: "PUT",
    description: "update service center details",
  },
  {
    name: "showServiceCenter",
    path: (params) => `/api/v3/crm/service_centers/${params.id}?fields=show`,
    method: "GET",
    description: "get service center details",
  },
  {
    name: "serviceCenterOperationalPincodes",
    path: (params) => `/api/v3/crm/service_centers/${params.id}/pincodes?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get service center associated operational pincodes",
  },
  {
    name: "rfidTypes",
    path: (params) => `/api/v3/crm/rfid_types?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all rfid types",
  },
  {
    name: "assetEarningConfigs",
    path: (params) => `/api/v3/crm/asset_earning_configs?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all asset earning configurations",
  },
  {
    name: "createRentalEarningConfig",
    path: (params) => `/api/v3/crm/asset_earning_configs`,
    method: "POST",
    description: "create new rental earnings configurations",
  },
  {
    name: "tallyTransactions",
    path: (params) => `/api/v3/crm/tally_transactions?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all tally transactions",
  },
  {
    name: "approveTallyTransaction",
    path: (params) => `/api/v1/tally_transactions/${params.id}/approve`,
    method: "POST",
    description: "approve tally transaction",
  },
  {
    name: "rejectTallyTransaction",
    path: (params) => `/api/v1/tally_transactions/${params.id}/reject`,
    method: "POST",
    description: "reject tally transaction",
  },
  {
    name: "walletCashbacks",
    path: (params) => `/api/v3/crm/wallet_cashbacks?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all wallet cashbacks",
  },
  {
    name: "uploaderHistories",
    path: (params) => `/api/v3/crm/uploader_histories?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all upload histories",
  },
  {
    name: "vehicles",
    path: (params) => `/api/v3/crm/vehicles?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all vehicles",
  },
  {
    name: "earnings",
    path: (params) => `/api/v3/crm/earnings?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all earnings",
  },
  {
    name: "partner_billings",
    path: (params) => `/api/v3/crm/partner_billings?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing all partner billings",
  },
  {
    name: "rental_bookings",
    path: (params) => `/api/v3/crm/rental_bookings?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing rental bookings",
  },
  {
    name: "rental_customers",
    path: (params) => `/api/v3/crm/rental_customers?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing rental customers",
  },
  {
    name: "transactions",
    path: (params) => `/api/v3/crm/transactions?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing customers transaction History",
  },
  {
    name: "rentalServiceCenters",
    path: (params) => `/api/v3/crm/service_centers/rental_service_centers?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing service centers (rentals)",
  },
  {
    name: "dropRentalBikeApi",
    path: (params) => `/api/v3/crm/rental_bookings/drop_vehicle?${prepareQueryParams(params)}`,
    method: "POST",
    description: "listing service centers (rentals)",
  },
  {
    name: "cancelDropRentalBikeApi",
    path: (params) => `/api/v3/crm/rental_bookings/cancel_drop_vehicle_request?${prepareQueryParams(params)}`,
    method: "POST",
    description: "listing service centers (rentals)",
  },
  {
    name: "partnerAssetBills",
    path: (params) => `/api/v3/partner_asset_bills?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing partner asset earning bills (rentals)",
  },
  {
    name: "bikes",
    path: (params) => `/api/v3/crm/bikes?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing bikes",
  },
  {
    name: "battery_swaps",
    path: (params) => `/api/v3/crm/battery_swaps?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing battery swaps",
  },
  {
    name: "user_documents",
    path: (params) => `/api/v3/crm/users/${params.id}/documents?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing documents of user",
  },
  {
    name: "business_units",
    path: (params) => `/api/v3/crm/corporate_fo/${params.id}/business_units?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing business_units of fleet owner",
  },
  {
    name: "showLeaseOffer",
    path: (params) => `/api/v3/crm/lease_offers/${params.id}?${prepareQueryParams(params)}`,
    method: "GET",
    description: "Details of lease offer",
  },
  {
    name: "createLeaseOffer",
    path: (params) => `/api/v3/crm/lease_offers?${prepareQueryParams(params)}`,
    method: "POST",
    description: "Create lease offer",
  },
  {
    name: "updateLeaseOffer",
    path: (params) => `/api/v3/crm/lease_offers/${params.id}?${prepareQueryParams(params)}`,
    method: "PUT",
    description: "Update lease offer",
  },
  {
    name: "rollOverConfigs",
    path: (params) => `/api/v3/crm/rollover_configs?${prepareQueryParams(params)}`,
    method: "GET",
    description: "Lease offer's roll over configurations listing",
  },
  {
    name: "createRollOverConfig",
    path: (params) => `/api/v3/crm/rollover_configs`,
    method: "POST",
    description: "Create rollover configuration for lease offer",
  },
  {
    name: "showRollOverConfig",
    path: (params) => `/api/v3/crm/rollover_configs/${params.id}`,
    method: 'GET',
    description: "Show lease offer's rollover configuration",
  },
  {
    name: "updateRollOverConfig",
    path: (params) => `/api/v3/crm/rollover_configs/${params.id}`,
    method: "PUT",
    description: "update lease offer's rollover configuration"
  },
  {
    name: "leads",
    path: (params) => `/api/v3/leads?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing leads"
  },
  {
    name: "leadsEarningConfig",
    path: (params) => `/api/v3/lead/earning_configuration?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing leads earning configurations"
  },
  {
    name: "createLeadsEarningConfig",
    path: (params) => `/api/v3/lead/earning_configuration?${prepareQueryParams(params)}`,
    method: "POST",
    description: "Create leads earning configuration"
  },
  {
    name: "showLeadsEarningConfig",
    path: (params) => `/api/v3/lead/earning_configuration/${params.id}`,
    method: 'GET',
    description: "Show leads earning configuration",
  },
  {
    name: "updateLeadsEarningConfig",
    path: (params) => `/api/v3/lead/earning_configuration/${params.id}`,
    method: "PUT",
    description: "update leads earning configuration"
  },
  {
    name: "glks",
    path: (params) => `/api/v3/crm/glks?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing GLKs(VAK)"
  },
  {
    name: "vakReports",
    path: (params) => `/api/v1/glk/reports?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing GLK Reports(VAK)"
  },
  {
    name: "showGlk",
    path: (params) => `/api/v3/crm/glks/${params.id}`,
    method: "GET",
    description: "Details of glk",
  },
  {
    name: "createGlk",
    path: (params) => `/api/v3/crm/glks?${prepareQueryParams(params)}`,
    method: "POST",
    description: "Create GLK(VAK)"
  },
  {
    name: "updateGlks",
    path: (params) => `/api/v3/crm/glks/${params.id}?${prepareQueryParams(params)}`,
    method: "PUT",
    description: "Update GLK(VAK)",
  },
  {
    name: "vakTransactions",
    path: (params) => `/api/v1/glk/transactions?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing GLK (VAK) Transactions",
  },
  {
    name: "showWorkOrder",
    path: (params) => `/api/v3/crm/work_orders/${params.id}`,
    method: "GET",
    description: "Show work order details",
  },
  {
    name: "serviceType",
    path: (params) => `/api/v3/service_type/base?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get baas or vaas of parent (Parent id is required)",
  },
  {
    name: "createServiceTypesMappings",
    path: (params) => `/api/v3/service_type/mappings?${prepareQueryParams(params)}`,
    method: "POST",
    description: "create service types mappings",
  },
  {
    name: "createUserPincodeMap",
    path: (params) => `/api/v2/area_user_mappings?${prepareQueryParams(params)}`,
    method: "POST",
    description: "create user area mappings",
  },
  {
    name: "userPincodeMap",
    path: (params) => `/api/v3/crm/users/${params.id}/area_mappings?${prepareQueryParams(params)}`,
    method: "GET",
    description: "create user area mappings",
  },
  {
    name: "users",
    path: (params) => `/api/v3/crm/users?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get users list",
  },
  {
    name: "mapUserServiceType",
    path: (params) => `/api/v3/service_type/mappings?${prepareQueryParams(params)}`,
    method: "POST",
    description: "create user service type mapping",
  },
  {
    name: "serviceTypeMapping",
    path: (params) => `/api/v3/service_type/mappings?${prepareQueryParams(params)}`,
    method: "GET",
    description: "listing user service type mapping",
  },
  {
    name: "updateServiceTypeMapping",
    path: (params) => `/api/v3/service_type/mappings/${params.id}`, /*?${prepareQueryParams(params)}`,*/
    method: "PUT",
    description: "update user service type mapping",
  },
  {
    name: "deleteUserAreaMapping",
    path: (params) => `/api/v2/area_user_mappings/${params.id}?${prepareQueryParams(params)}`,
    method: "DELETE",
    description: "delete area user mappings",
  },
  {
    name: "rentalCustomerDetails",
    path: (params) => `/api/v3/crm/rental_customers/${params.id}?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get rental customer details",
  },
  {
    name: "showPartnerBilling",
    path: (params) => `api/v3/crm/partner_billings/${params.id}?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get details of the partner billings",
  },
  {
    name: "monthlyEarngingDetails",
    path: (params) => `api/v2/earnings/daily_earnings.json?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get earning details of a distributor for some month",
  },
  {
    name: "finalizePartnerBill",
    path: (params) => `api/v2/partner_billings/finalize_bill.json?${prepareQueryParams(params)}`,
    method: "GET",
    description: "finalize an unpaid bill",
  },
  {
    name: "payPartnerBill",
    path: (params) => `api/v2/partner_billings/payment_to_partner`,
    method: "POST",
    description: "pay amount to partner for bill",
  },
  {
    name: "canAutoFinalizeBill",
    path: (params) => `/api/v2/partner_billings/set_auto_finalize_bill?${prepareQueryParams(params)}`,
    method: "GET",
    description: "setting auto finalize bill for cp or pp to true  or false",
  },
  {
    name: "canRaiseElectricityBill",
    path: (params) => `/api/v3/crm/charging_partners/${params.id}/toggle_electricity_billing`,
    method: "GET",
    description: "get if user can raise electricity bill or not (true  or false)",
  },
  {
    name: "enablePPForRental",
    path: (params) => `/api/v3/crm/platform_partners/${params.id}/enable_for_rental?${prepareQueryParams(params)}`,
    method: "GET",
    description: "make PP enable for rental",
  },
  {
    name: "disablePPForRental",
    path: (params) => `/api/v3/crm/platform_partners/${params.id}/disable_for_rental?${prepareQueryParams(params)}`,
    method: "GET",
    description: "make PP disable for rental",
  },
  {
    name: "getPincode",
    path: (params) => `/api/v3/crm/pincodes/${params.id}?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get pincodes",
  },
  {
    name: "updatePincode",
    path: (params) => `/api/v3/crm/pincodes/${params.id}?${prepareQueryParams(params)}`,
    method: "PUT",
    description: "update pincodes",
  },
  {
    name: "showTechnician",
    path: (params) => `/api/v3/crm/technicians/${params.id}?${prepareQueryParams(params)}`,
    method: "GET",
    description: "show technician",
  },
  {
    name: "updateTechnician",
    path: (params) => `/api/v3/crm/technicians/${params.id}?${prepareQueryParams(params)}`,
    method: "PUT",
    description: "update technician",
  },
  {
    name: "createTechnician",
    path: (params) => `/api/v3/crm/technicians?${prepareQueryParams(params)}`,
    method: "POST",
    description: "create technician"
  },
  {
    name: "createCoordinator",
    path: (params) => `/api/v3/crm/dsc_coordinators?${prepareQueryParams(params)}`,
    method: "POST",
    description: "create coordinator"
  },
  {
    name: "showCoordinator",
    path: (params) => `/api/v3/crm/dsc_coordinators/${params.id}?${prepareQueryParams(params)}`,
    method: "GET",
    description: "show coordinator",
  },
  {
    name: "updateCoordinator",
    path: (params) => `/api/v3/crm/dsc_coordinators/${params.id}?${prepareQueryParams(params)}`,
    method: "PUT",
    description: "update cooordinator",
  },
  {
    name: "products",
    path: (params) => `/api/v3/crm/products?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get products",
  },
  {
    name: "transaction_orders",
    path: (params) => `/api/v3/crm/transaction_orders?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get transaction orders",
  },
  {
    name: "merchants",
    path: (params) => `/api/v2/merchants/show_all?${prepareQueryParams(params)}`,
    method: "GET",
    description: "get merchants",
  },
]

const prepareBuilderEndpoint = (builder, endpoint_config) => {
  let mutation = null;
  if (endpoint_config.method === "GET") {
    mutation = builder.mutation({
      query: (params) => ({
        url: endpoint_config.path(params),
        method: endpoint_config.method,
        params: {},
      }),
    })
  } else {
    mutation = builder.mutation({
      query: (body) => ({
        url: endpoint_config.path(body),
        method: endpoint_config.method,
        body: JSON.parse(JSON.stringify(body)),
      }),
    })
  }
  return mutation;
}

const prepareBuilderEndpoints = (builder, endpoints_config) => {
  let builderEndpoints = endpoints_config.reduce((obj, endpoint_config) => {
    obj[endpoint_config.name] = prepareBuilderEndpoint(builder, endpoint_config);
    return obj;
  }, {})
  return builderEndpoints;
}

const endpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => (prepareBuilderEndpoints(builder, endpoints_config)),
});


export const getApi = (apiName) => {
  if (!apiName) {
    return [null]
  }
  if (endpoints[`use${apiName.charAt(0).toUpperCase()}${apiName.slice(1)}Mutation`]) {
    return endpoints[`use${apiName.charAt(0).toUpperCase()}${apiName.slice(1)}Mutation`]();
  } else {
    return [null]
  }
}

export const callApi = async (api, data) => {
  if (!data) {
    data = {}
  }
  // eslint-disable-next-line no-unused-vars
  let response = {};
  try {
    return await api(data);
  }
  catch (error) {
    return error;
  }
}

export const handleResponse = (navigate, response, successCallback, errorCallback) => {
  if (response.error) {
    if (response.error.status === 403) {
      navigate("/")
    } else {
      if (errorCallback) {
        errorCallback(response.error)
      } else {
        alert("Error occurred while connecting to server...")
      }
    }
  } else {
    successCallback(response.data.data)
  }
}

export default endpoints;
